import React from 'react';

import FontDefinition from '../font_definition';

const { $ } = window;

export default class FontDefinitionsDialog extends React.Component {
  constructor(props) {
    super(props);

    let data = {};
    Object.keys(props).forEach(key => data[key] = props[key]);
    this.state = data;
    this.state.fontDefinitions = this.state.toolbar.state.project.fontDefinitions;
  }

  componentWillReceiveProps(props) {
    this.setState(props);
    this.setState({
      fontDefinitions: this.state.toolbar.state.project.fontDefinitions
    });
  }

  componentDidMount() {
    $('#font-definitions-dialog.ui.modal').modal({
      onHidden: () => this.hide(),
      onApprove: () => this.hide()
    });
  }

  componentDidUpdate() {
    $('#font-definitions-dialog.ui.modal').modal(this.props.visible ? 'show' : 'hide');
  }

  hide() {
    this.state.toolbar.setState({
      showFontDefinitionsDialog: false
    });
  }

  remove(name) {
    this.state.toolbar.state.project.updateFontDefinition(name, null);
  }

  render() {
    let project = this.state.project;

    let removeStroke = (style) => {
      delete style.webkitTextStroke;
      delete style.webkitTextFillColor;
      return style;
    };

    let absolute = (style) => {
      style.position = 'absolute';
      style.left = 0;
      style.top = 0;
      style.right = 0;
      style.bottom = 0;
      return style;
    };

    return (
      <div className="ui modal" id="font-definitions-dialog">
        <div className="header">
          Пресеты шрифтов
        </div>
        <div className="content">
          <div className="ui segment">
            <div className="ui relaxed divided list">
              {this.state.fontDefinitions.map(fd => (
                <div className="item" key={fd.name}>
                  <div className="right floated content">
                    <button className="ui icon button" onClick={this.remove.bind(this, fd.name)}>
                      <i className="remove icon" />
                    </button>
                  </div>
                  <div className="content">
                    <div className="header">
                      <div style={{position: 'relative'}}>
                        <div style={absolute(fd.css(true))}>
                          {fd.name}
                        </div>
                        <div style={absolute(removeStroke(fd.css(true)))}>
                          {fd.name}
                        </div>
                      </div>
                    </div>
                    {fd.fontFamily}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="actions">
          <button className="ui right primary approve button">Ок</button>
        </div>
      </div>
    );
  }
}
